'use client'

import { Play } from "lucide-react";
import { useState } from "react";
import { Dialog, DialogContent } from "@/ui/shadcn/dialog";

export function TutorialsBlock(datas) {
	const [isOpen, setIsOpen] = useState(false);
	const [videoLink, setVideoLink] = useState("");

	const openVideo = (link) => {
		setVideoLink(link);
		setIsOpen(true);
	};

	return (
		<div className="container py-6">
			<h2 className="text-3xl font-bold font-alt mb-4">{datas.title}</h2>
			<div className="flex flex-col gap-8">
				{datas.tutorials.map((item, index) => (
					<div key={index} className="flex flex-col md:flex-row items-center w-full md:gap-6">
						<div className="relative w-full md:w-1/3 h-full">
							<img src={item.image.s3Url} alt="image" className="w-full h-[250px] object-cover rounded-lg" />
							<button 
								onClick={() => openVideo(item.youtubeVideo)}
								className="absolute inset-0 flex items-center justify-center cursor-pointer group"
							>
								<span className="bg-primary p-2 rounded-full shadow-lg group-hover:bg-primary-800 transition-all">
									<Play className="w-6 h-6 text-white" />
								</span>
							</button>
						</div>
						<div className="w-full md:w-2/3 py-3 md:py-5">
							<h2 className="text-xl md:text-2xl font-bold font-alt mb-3">
								{item.title}
							</h2>
							<p className="text-sm text-gray-500">
								{item.description}
							</p>
						</div>
					</div>
				))}
			</div>

			<Dialog open={isOpen} onOpenChange={setIsOpen}>
				<DialogContent className="sm:max-w-[800px]">
					<div className="aspect-video">
						<iframe
							className="w-full h-full"
							src={videoLink}
							title="YouTube video player"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						/>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	)
}
